/**
 * Glifo cartella: tracciato pieno al colore, interno semi-trasparente.
 *
 * Non è un Material Symbol perché quel font è o pieno o vuoto: l'asse `FILL`
 * vale 0 o 1, e non esiste un valore intermedio. Serviva invece un contorno
 * netto con l'interno appena accennato, e con due `path` sullo stesso tracciato
 * si ottiene esattamente quello — il primo riempie al 18%, il secondo disegna
 * il bordo sopra.
 *
 * `currentColor` su entrambi: il colore lo decide chi lo usa, tramite `color`
 * del contenitore. Così la stessa forma serve varianti grafiche diverse senza
 * saperne nulla.
 */

/**
 * Il tracciato, esportato: la stessa forma serve anche allo stato vuoto e al
 * badge delle pastiglie, che però hanno spessori e dimensioni proprie. Condividere
 * la stringa evita che tre copie divergano; condividere il componente
 * costringerebbe a parametrizzare stile e misure per nulla.
 */
export const FOLDER_PATH =
  'M3 7.5A1.5 1.5 0 0 1 4.5 6h4.2l1.8 2h9A1.5 1.5 0 0 1 21 9.5v8A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5v-10Z';

export function FolderGlyph({ size = 22 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true">
      <path d={FOLDER_PATH} fill="currentColor" opacity="0.18" />
      {/* Lo spessore non scala con `size`: a 1.5 il bordo resta leggibile sia a
          14px sia a 24px, mentre un tratto proporzionale sparirebbe da piccolo. */}
      <path d={FOLDER_PATH} stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
